import DHowResults from './DHowResults'

export default DHowResults
